var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main"},[_c('div',{staticStyle:{"padding-bottom":"20px"},attrs:{"align":"center"}},[_c('img',{attrs:{"src":_vm.logo,"width":"75"}})]),_c('div',{staticClass:"box"},[_c('div',{staticClass:"maincontent"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }